
import AuthReducer from './signIn/reducer';

export default {
  auth: AuthReducer,
};
